<template>
  <dl class="input-block">
    <dt>備考</dt>
    <dd>
      <textarea class="textarea" rows="4" v-model="_value"></textarea>
    </dd>
  </dl>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'RemarksInput',
  computed: {
    ...mapState({
      remarks: state => state.reserves.edit.reservation.remarks,
    }),
    _value: {
      get() {
        return this.remarks
      },
      set(remarks) {
        this.$store.commit('reserves/edit/update', { remarks })
      },
    },
  },
}
</script>
